import {
  breakpoint,
  border,
  boxShadow,
  color,
  fontWeight,
  row,
  scale,
  spacing,
  zIndex,
} from '@sendgrid/design-primitives/tokens/sg-dot-com/es6/base.es6';

breakpoint.breakpointPricingLarge = '1286px';
breakpoint.breakpointNavXl = '1300px';
breakpoint.breakpointNavLg = '1148px';
breakpoint.breakpointNavMd = '1060px';

color.colorGray25 = '#fafbff';

const transparentHeader = {
  transparentHeaderMargin: '-78px',
  transparentHeaderPadding: '128px',
};

const colorNew = {
  blueDark: "#000e35",
  blueMed: "#2c4a7d",
  blueLight: "#3368FA",
}

const font = {
  whitneyLight: `
    font-family: "Whitney SSm A", "Whitney SSm B", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 300;
  `,
  whitneyBook: `
    font-family: "Whitney SSm A", "Whitney SSm B", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 400;
  `,
  whitneyMedium: `
    font-family: "Whitney SSm A", "Whitney SSm B", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-weight: 500;
  `,
  whitneySemibold: `
    font-family: "Whitney SSm A", "Whitney SSm B", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 600;
  `,
  whitneyBold: `
    font-family: "Whitney SSm A", "Whitney SSm B", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 700;
  `,
};

const Theme = {
  breakpoint,
  border,
  boxShadow,
  color,
  colorNew,
  fontWeight,
  transparentHeader,
  row,
  scale,
  spacing,
  zIndex,
  font,
};

export default Theme;
